export const SIGNINPAGE_USERNAME = "SIGNINPAGE_USERNAME";
export const SIGNINPAGE_PASSWORD = "SIGNINPAGE_PASSWORD";
export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const USER_FETCH_SUCCEEDED = "USER_FETCH_SUCCEEDED";
export const USER_FETCH_FAILED = "USER_FETCH_FAILED";
export const USER_FETCHSTATE_REFRESH = "USER_FETCHSTATE_REFRESH";
export const USER_DETAILS = "USER_DETAILS";
